import { registerBlockType } from '@wordpress/blocks';
import './style.scss';

import attributes from './attributes';
import metadata from './block.json';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';

/**
 * Block Registration
 */
registerBlockType(metadata, {
    icon: {
        src: (
            <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
                <rect rx=".5" strokeWidth="1.5" height={11} width="22.5" y="6.5" x=".75" stroke="#2563eb" fill="#fff" />
                <rect stroke="#2563eb" rx=".2" height="1.375" width="11.875" y="11.313" x="3.625" strokeWidth="1.5" fill="#fff" />
                <circle cy={12} cx="20.25" strokeWidth="1.5" stroke="#2563eb" fill="#fff" r=".563" />
            </svg>
        )
    },
    attributes,
    edit: Edit,
    save: Save
});
